interface HtmlValidationResult {
  isValid: boolean;
  error?: string;
}

interface DangerousPattern {
  pattern: RegExp;
  message: string;
}

const DANGEROUS_PATTERNS: DangerousPattern[] = [
  // Script execution (XSS)
  {
    pattern: /<script[\s>/]/i,
    message: 'Script tags are not allowed',
  },
  {
    pattern: /\bon\w+\s*=/i,
    message: 'Event handler attributes are not allowed',
  },
  {
    pattern: /javascript\s*:/i,
    message: 'javascript: URLs are not allowed',
  },
  {
    pattern: /vbscript\s*:/i,
    message: 'vbscript: URLs are not allowed',
  },
  {
    pattern: /data\s*:\s*text\/html/i,
    message: 'data:text/html URIs are not allowed',
  },
  {
    pattern: /data\s*:[^,]*;base64/i,
    message: 'Base64-encoded data URIs are not allowed',
  },

  // Phishing
  {
    pattern: /<meta[^>]+http-equiv\s*=\s*["']?\s*refresh/i,
    message: 'Meta refresh redirects are not allowed',
  },
  {
    pattern: /<input[^>]+type\s*=\s*["']?\s*password/i,
    message: 'Password input fields are not allowed',
  },

  // Dangerous nested elements
  {
    pattern: /<(?:object|embed|applet)[\s>/]/i,
    message: 'Plugin elements (object, embed, applet) are not allowed',
  },
];

/**
 * Validate embed HTML code for security.
 * Rejects HTML containing dangerous patterns (XSS, phishing, dangerous elements).
 */
export function validateEmbedHtmlCode(html: string): HtmlValidationResult {
  if (!html || !html.trim()) {
    return { isValid: true };
  }

  for (const { pattern, message } of DANGEROUS_PATTERNS) {
    if (pattern.test(html)) {
      return { isValid: false, error: message };
    }
  }

  return { isValid: true };
}
